/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, JobDetailsModel } from '@gh/builder-shared';
import { getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { TranslationService, translationTuple } from '@gh/core-mls';
import { GridDefinition, GridDefinitionFactory } from '@gh/core-ui-grid';
import { assign } from 'lodash';
import { JobRfq, JobRfqInspectionItem } from '../../../resources/job-details-tab/job-details-tab-model';
import { JobDetailsRfqTabFormState } from './job-details-rfq-tab-form.service';

@Component({
  selector: 'gh-job-details-rfq-tab',
  template: require('./job-details-rfq-tab.component.html'),
  providers: [JobDetailsRfqTabFormState],
})
export class JobDetailsRfqTabComponent implements OnInit {
  rfq: JobRfq;
  jobId: ID;
  gridDefinition: GridDefinition;

  constructor(public form: JobDetailsRfqTabFormState,
              private model: JobDetailsModel,
              private translations: TranslationService,
              private route: ActivatedRoute,
              private gridDefinitionFactory: GridDefinitionFactory,
              public navigationService: BuilderNavigationService) {
  }

  get isQuickJob(): boolean {
    return this.rfq.isQuickJob;
  }

  ngOnInit(): void {
    const { rfq, jobId } = getRouteInitData(this.route);
    assign(this, { rfq, jobId });

    this.gridDefinition = this.gridDefinitionFactory.buildManual(
      [{
        field: 'name',
        headerName: this.translations.get('lbl_title'),
      }, {
        field: 'value',
        headerName: this.translations.get('lbl_selection'),
        width: 200,
        suppressSizeToFit: true,
      }],
      {
        getRowNodeId: (data: JobRfqInspectionItem) => data.name,
      });

    this.form.build(rfq);
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.jobId,
      entityType: 'JOB',
      label: translationTuple('lbl_job_number_with_param', { number: String(this.model.jobNumber) }),
    });
  }
}
